import { render, staticRenderFns } from "./CampaignPointsPagesContainer.vue?vue&type=template&id=9a71adb2&"
import script from "./CampaignPointsPagesContainer.vue?vue&type=script&lang=js&"
export * from "./CampaignPointsPagesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports